module.exports = __webpack_public_path__ + "img/akinder_logo_without_text.6b95f484.svg";